import { normalizeSiteRuntime } from '@/utils/siteRuntime'
import { getThemeColor } from '@/utils/theme'

const ROUTE_COLORS = Array.from({ length: 16 }, (_, index) => `routePalette${index + 1}`)

export function getGroundStationRouteOverlays (routes, sites, planes, orders = null) {
  const routeMap = new Map()
  sites.forEach(site => {
    const runtime = normalizeSiteRuntime(site)
    runtime.bindRouteArray.forEach((routeId, slotIndex) => {
      const route = routes.find(item => String(item.id) === String(routeId) && String(item.shop_id) === String(site.shop_id))
      if (!route || !route.route_data) return
      const runningPlaneId = String(runtime.runingArray[slotIndex] || '').trim()
      const runningPlane = planes.find(plane => String(plane.id) === runningPlaneId && String(plane.shop_id) === String(site.shop_id))
      const active = Boolean(runningPlane) && (!orders || orders.some(order =>
        String(order.shop_id) === String(site.shop_id) && String(order.by_plane_id) === runningPlaneId &&
        order.shipment_status === '已发货' && String(order.mission_route_id) === String(route.id) && order.mission_token))
      let routeData
      try {
        routeData = typeof route.route_data === 'string' ? JSON.parse(route.route_data) : route.route_data
      } catch (error) {
        if (!(error instanceof SyntaxError)) throw error
        console.warn('[Home] 站点绑定航线数据格式异常，已跳过', route)
        return
      }
      const planeColor = String(runningPlane?.color || '').trim().toUpperCase()
      const descriptor = {
        routeId: String(route.id),
        shopId: String(site.shop_id || ''),
        routeName: route.name,
        siteName: site.sitename,
        routeData,
        active,
        planeId: active ? String(runningPlane.id) : '',
        color: active
          ? (/^#[0-9A-F]{6}$/.test(planeColor) ? planeColor : getThemeColor('primary'))
          : (/^#[0-9A-Fa-f]{6}$/.test(String(route.color || '')) ? route.color : null)
      }
      const previous = routeMap.get(descriptor.routeId)
      if (!previous || descriptor.active) routeMap.set(descriptor.routeId, descriptor)
    })
  })
  const colorByRouteId = new Map(
    Array.from(routeMap.keys()).sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
      .map((routeId, index) => [routeId, ROUTE_COLORS[index % ROUTE_COLORS.length]])
  )
  return Array.from(routeMap.values()).map(route => ({ ...route, color: route.color || getThemeColor(colorByRouteId.get(route.routeId)) }))
}
